import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminCallbacksQuery.ts
var r = (r = {}) => t({
	queryKey: e.callbacks(r),
	fetchPage: (e) => n.adminListCallbacks({
		...r,
		page: e
	}),
	key: "items"
});
//#endregion
export { r as useAdminCallbacksQuery };
